// UI density toggle (ART-24).
//
// Two display densities for the app shell + tables: the default `compact`
// (tight padding, smaller rows) and `comfortable` (roomier). The chosen mode
// persists under the `ui.density` localStorage key so it survives reloads.
//
// `comfortable` is applied by toggling the `density-comfortable` class on the
// <html> element — prototype.css already wires `html.density-comfortable` to a
// roomier set of density CSS vars (--row-pad-y/-x, --row-font, --section-gap).

export type Density = 'compact' | 'comfortable';

const STORAGE_KEY = 'ui.density';
const COMFORTABLE_CLASS = 'density-comfortable';

/**
 * Read the persisted density. Defaults to `compact` when nothing is stored or
 * the stored value is unrecognised, so callers never have to guard.
 */
export function getDensity(): Density {
  return localStorage.getItem(STORAGE_KEY) === 'comfortable' ? 'comfortable' : 'compact';
}

/**
 * Apply a density: toggles the `density-comfortable` class on <html> and
 * persists the choice to localStorage.
 */
export function setDensity(mode: Density): void {
  document.documentElement.classList.toggle(COMFORTABLE_CLASS, mode === 'comfortable');
  localStorage.setItem(STORAGE_KEY, mode);
}
